import React, { useState } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import cx from 'classnames';

import Slider from 'react-slick';

import { breakpoints } from 'shared/Responsive';
import Image from 'shared/Image';
import CircleArrowButton from 'apps/ask/components/CircleArrowButton';

import TreatmentIcon from 'images/ask/health/treatment-icon.svg';

function TreatmentCard({ name, url, image_url, quantity }) {
  return (
    <div className="treatment-card">
      <div className="treatment-card__image">
        <Image src={image_url} renderOnError={<img src={TreatmentIcon} />} />
      </div>
      <div className="treatment-card__summary">
        <div className="treatment-card__title" title={name}>
          {name}
        </div>
        <div className="treatment-card__quantity">
          {quantity}
        </div>
        <div className="treatment-card__link">
          <a className="button button--medium button--gradient" target="_blank" rel="noreferrer noopener" href={url}>Buy now</a>
        </div>
      </div>
    </div>
  );
}

TreatmentCard.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  quantity: PropTypes.string.isRequired,
  image_url: PropTypes.string.isRequired
};

const CATEGORIES = {
  otc: 'OVER-THE-COUNTER',
  at_home: 'HOME REMEDY'
};

function ConditionTreatments({ treatments }) {
  const settings = {
    speed: 300,
    infinite: true,
    autoplay: false,
    pauseOnHover: true,
    swipeToSlide: true,
    slidesToShow: 3,
    nextArrow: <CircleArrowButton direction="right" />,
    prevArrow: <CircleArrowButton direction="left" />,
    responsive: [
      {
        breakpoint: breakpoints.tablet,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const treatmentsByCategory = groupBy(
    sortBy(treatments, (t) => Object.keys(CATEGORIES).indexOf(t.category)),
    'category'
  );
  const categories = Object.keys(treatmentsByCategory);

  if (!categories.length) return null;

  const [selectedCategory, selectCategory] = useState(categories[0]);

  return (
    <div className="condition-treatments">
      <div className="condition-treatments--tabs">
        {
          categories.map((category) =>
            treatmentsByCategory[category].length && (
              <div key={category} className={cx('condition-treatments--tab', {active: selectedCategory === category})} onClick={() => selectCategory(category)}>
                {CATEGORIES[category] || category}
              </div>
            )
          )
        }
      </div>

      <Slider {...settings}>
        {
          treatmentsByCategory[selectedCategory].map(t => <TreatmentCard key={t.name} {...t} />)
        }
      </Slider>
    </div>
  );
}

ConditionTreatments.propTypes = {
  treatments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      quantity: PropTypes.string.isRequired,
      image_url: PropTypes.string.isRequired
    })
  )
};

export default ConditionTreatments;
